"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _text = require("@mmc/text");
var _commonCta = require("@mmc/common-cta");
var _reactRedux = require("react-redux");
var _commonI18n = require("@mmc/common-i18n");
var _commonRichText = require("@mmc/common-rich-text");
var _cardContent = _interopRequireDefault(require("../styles/card-content.css"));
var _editorialCards = _interopRequireDefault(require("./editorial-cards.props/editorial-cards.propTypes"));
var _specialOffer = _interopRequireDefault(require("./special-offer"));
var _specifications = _interopRequireDefault(require("./specifications"));
var _features = _interopRequireDefault(require("./features/features"));
var _div, _div2; // eslint-disable-line import/no-named-as-default
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;
var CardContent = function CardContent(_ref) {
  var theme = _ref.theme,
    content = _ref.content,
    editorialLayout = _ref.editorialLayout,
    themeAlignment = _ref.themeAlignment,
    cardType = _ref.cardType,
    config = _ref.config,
    disclaimerData = _ref.disclaimerData,
    addPriceDisclaimer = _ref.addPriceDisclaimer,
    priceDisclaimerId = _ref.priceDisclaimerId;
  var renderSpecs = function renderSpecs(specs) {
    return specs && specs !== ' ' && specs.map(function (el) {
      return /*#__PURE__*/_react["default"].createElement(_specifications["default"], {
        key: handleNestedProp(el, 'el.label'),
        label: handleNestedProp(el, 'el.label'),
        image: handleNestedProp(el, 'el.image.image'),
        theme: theme,
        disclaimerData: disclaimerData
      });
    });
  };
  var highLowRender = function highLowRender(contentObj, themeObj) {
    var _contentObj$descripti, _contentObj$descripti2, _contentObj$descripti3, _contentObj$descripti4, _contentObj$link;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs'] + " " + (theme[themeAlignment + "-xs"] ? theme[themeAlignment + "-xs"] : '') + " " + _cardContent["default"].noGutters + " " + (cardType && _cardContent["default"][cardType]) + " " + (handleNestedProp(contentObj, 'content.description.textAlignment') !== ' ' && _cardContent["default"][contentObj.description.textAlignment])
    }, ((_contentObj$descripti = contentObj.description) == null ? void 0 : _contentObj$descripti.sectionHeading) && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
        theme: theme,
        html: handleNestedProp(contentObj, 'contentObj.description.sectionHeading'),
        className: themeObj.marginBottom20 + " " + themeObj.labelMedium + " " + _cardContent["default"].greyButton,
        tagName: "h2"
      }),
      disclaimerData: disclaimerData
    }), ((_contentObj$descripti2 = contentObj.description) == null ? void 0 : _contentObj$descripti2.mainHeading) && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: handleNestedProp(contentObj, 'contentObj.description.mainHeading'),
      className: themeObj.marginBottom20 + " " + themeObj.headingThree,
      tag: "h3",
      disclaimerData: disclaimerData
    }), ((_contentObj$descripti3 = contentObj.description) == null ? void 0 : _contentObj$descripti3.paragraph) && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
        theme: theme,
        html: handleNestedProp(contentObj, 'contentObj.description.paragraph'),
        className: themeObj.bodyCopy + " " + _cardContent["default"].greyButton,
        tagName: "p"
      }),
      disclaimerData: disclaimerData
    }), ((_contentObj$descripti4 = contentObj.description) == null ? void 0 : _contentObj$descripti4.legal) && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
        theme: theme,
        html: handleNestedProp(contentObj, 'contentObj.description.legal'),
        className: themeObj.marginBottom20 + " " + themeObj.tags,
        tagName: "p"
      }),
      disclaimerData: disclaimerData
    }), ((_contentObj$link = contentObj.link) == null ? void 0 : _contentObj$link.url) && /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + themeObj.marginTop40
    }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      classes: [_cardContent["default"].ctaHighLow, _cardContent["default"].adjustIconPosition],
      theme: themeObj,
      "data-section": handleNestedProp(contentObj, 'contentObj.description.mainHeading'),
      data: {
        label: handleNestedProp(contentObj, 'contentObj.link.label'),
        url: handleNestedProp(contentObj, 'contentObj.link.url'),
        priority: handleNestedProp(contentObj, 'contentObj.link.priority'),
        openNewTab: handleNestedProp(contentObj, 'contentObj.link.openNewTab'),
        icon: handleNestedProp(contentObj, 'contentObj.link.icon')
      }
    }))));
  };
  var mediumRender = function mediumRender(contentObj, themeObj) {
    var _contentObj$descripti5, _contentObj$descripti6, _contentObj$descripti7, _contentObj$link2;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, handleNestedProp(contentObj, 'contentObj.link.url') ? /*#__PURE__*/_react["default"].createElement(_text.Text, {
      tag: "h2",
      className: themeObj.marginBottom20 + " " + themeObj.headingThree + " " + _cardContent["default"].mediumCardHeading,
      text: handleNestedProp(contentObj, 'contentObj.description.sectionHeading'),
      disclaimerData: disclaimerData
    }) : /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: handleNestedProp(contentObj, 'contentObj.description.sectionHeading'),
      className: themeObj.marginBottom20 + " " + themeObj.headingThree + " " + _cardContent["default"].mediumCardHeading,
      tag: "h2",
      disclaimerData: disclaimerData
    }), ((_contentObj$descripti5 = contentObj.description) == null ? void 0 : _contentObj$descripti5.mainHeading) && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: handleNestedProp(contentObj, 'contentObj.description.mainHeading'),
      className: themeObj.marginBottom20 + " " + themeObj.headingSix,
      disclaimerData: disclaimerData
    }), ((_contentObj$descripti6 = contentObj.description) == null ? void 0 : _contentObj$descripti6.paragraph) && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
        theme: theme,
        html: handleNestedProp(contentObj, 'contentObj.description.paragraph')
      }),
      disclaimerData: disclaimerData,
      className: themeObj.marginBottom20 + " " + themeObj.bodyCopy + " " + _cardContent["default"].greyButton
    }), ((_contentObj$descripti7 = contentObj.description) == null ? void 0 : _contentObj$descripti7.legal) && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
        theme: theme,
        html: handleNestedProp(contentObj, 'contentObj.description.legal'),
        className: themeObj.marginBottom20 + " " + themeObj.tags,
        tagName: "p"
      }),
      disclaimerData: disclaimerData
    }), ((_contentObj$link2 = contentObj.link) == null ? void 0 : _contentObj$link2.label) && /*#__PURE__*/_react["default"].createElement("div", {
      className: _cardContent["default"].boxWrapper + " " + (contentObj.link.priority !== 'low' && contentObj.link.priority !== 'lowIcon' && _cardContent["default"].cta)
    }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      classes: [_cardContent["default"].ctaMed],
      theme: themeObj,
      data: {
        label: handleNestedProp(contentObj, 'contentObj.link.label'),
        url: handleNestedProp(contentObj, 'contentObj.link.url'),
        priority: handleNestedProp(contentObj, 'contentObj.link.priority'),
        openNewTab: handleNestedProp(contentObj, 'contentObj.link.openNewTab'),
        icon: handleNestedProp(contentObj, 'contentObj.link.icon')
      },
      mouseDownEvent: function mouseDownEvent() {
        return pushDataToDatalayer(contentObj);
      }
    })));
  };
  var pushDataToDatalayer = function pushDataToDatalayer(contentObj) {
    var market = config.market;
    if (market.toLowerCase() === 'nl' && typeof window !== 'undefined' && window.dataLayer && window.location && window.location.pathname && window.location.pathname.includes('/brochuredownload')
    //to check url
    ) {
      var model = handleNestedProp(contentObj, 'contentObj.description.mainHeading');
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        brochureDownload: model
      });
    }
  };
  var ifIsLanguageMasters = function ifIsLanguageMasters(contentObj) {
    return config.market === 'language-masters' && contentObj.description.paragraph ? 'From $XX,XXX.XX' : '';
  };
  var largeRender = function largeRender(contentObj, themeObj) {
    var _contentObj$descripti8, _contentObj$price, _contentObj$descripti9, _contentObj$descripti0, _contentObj$link3, _contentObj$link4, _contentObj$link5;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, ((_contentObj$descripti8 = contentObj.description) == null ? void 0 : _contentObj$descripti8.sectionHeading) && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: handleNestedProp(contentObj, 'contentObj.description.sectionHeading'),
      className: themeObj.marginBottom10 + " " + themeObj.headingThree + " " + _cardContent["default"].disclaimerDataWrapper,
      tag: "h2",
      disclaimerData: disclaimerData
    }), (((_contentObj$price = contentObj.price) == null ? void 0 : _contentObj$price.value) || ifIsLanguageMasters(contentObj)) && /*#__PURE__*/_react["default"].createElement("div", {
      className: _cardContent["default"].priceWrapper + " " + themeObj.marginBottom20
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: themeObj.headingSix + " " + _cardContent["default"].priceMargin
    }, handleNestedProp(contentObj, 'contentObj.price.value') !== ' ' ? /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
      format: "price",
      options: {
        value: handleNestedProp(contentObj, 'contentObj.price.value'),
        currency: handleNestedProp(config, 'config.currencyFormat'),
        locale: handleNestedProp(config, 'config.localeCode'),
        displayValue: handleNestedProp(contentObj, 'contentObj.price.displayValue'),
        zeroMessage: handleNestedProp(contentObj, 'contentObj.price.zeroMessage')
      },
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: priceDisclaimerId,
      disclaimerData: disclaimerData
    }) : ifIsLanguageMasters(contentObj)), /*#__PURE__*/_react["default"].createElement(_specialOffer["default"], {
      theme: themeObj,
      label: handleNestedProp(contentObj, 'contentObj.tag.label'),
      disclaimerData: disclaimerData
    })), ((_contentObj$descripti9 = contentObj.description) == null ? void 0 : _contentObj$descripti9.paragraph) && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
        theme: theme,
        html: handleNestedProp(contentObj, 'contentObj.description.paragraph')
      }),
      disclaimerData: disclaimerData,
      className: themeObj.marginBottom20 + " " + themeObj.bodyCopy + " " + _cardContent["default"].greyButton
    }), ((_contentObj$descripti0 = contentObj.description) == null ? void 0 : _contentObj$descripti0.legal) && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
        theme: theme,
        html: handleNestedProp(contentObj, 'contentObj.description.legal'),
        className: themeObj.marginBottom20 + " " + themeObj.tags,
        tagName: "p"
      }),
      disclaimerData: disclaimerData
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _cardContent["default"].boxWrapper
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _cardContent["default"].lrgBottomContent
    }, config.market !== 'us' && /*#__PURE__*/_react["default"].createElement("div", {
      className: _cardContent["default"].renderSpecsWrapper
    }, renderSpecs(handleNestedProp(contentObj, 'contentObj.specifications'))), /*#__PURE__*/_react["default"].createElement(_features["default"], {
      theme: theme,
      features: contentObj.icons,
      disclaimerData: disclaimerData
    }), (((_contentObj$link3 = contentObj.link) == null ? void 0 : _contentObj$link3.label) || ((_contentObj$link4 = contentObj.link2) == null ? void 0 : _contentObj$link4.label) || ((_contentObj$link5 = contentObj.link3) == null ? void 0 : _contentObj$link5.label)) && /*#__PURE__*/_react["default"].createElement("div", {
      className: _cardContent["default"].links
    }, contentObj.link && contentObj.link.label && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      theme: themeObj,
      data: {
        label: handleNestedProp(contentObj, 'contentObj.link.label'),
        url: handleNestedProp(contentObj, 'contentObj.link.url'),
        priority: handleNestedProp(contentObj, 'contentObj.link.priority'),
        openNewTab: handleNestedProp(contentObj, 'contentObj.link.openNewTab'),
        icon: handleNestedProp(contentObj, 'contentObj.link.icon')
      },
      classes: [_cardContent["default"].mobileFullWidth]
    }), contentObj.link2 && contentObj.link2.label && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      theme: themeObj,
      data: {
        label: handleNestedProp(contentObj, 'contentObj.link2.label'),
        url: handleNestedProp(contentObj, 'contentObj.link2.url'),
        priority: handleNestedProp(contentObj, 'contentObj.link2.priority'),
        openNewTab: handleNestedProp(contentObj, 'contentObj.link2.openNewTab'),
        icon: handleNestedProp(contentObj, 'contentObj.link2.icon')
      },
      classes: [_cardContent["default"].mobileFullWidth]
    }), contentObj.link3 && contentObj.link3.label && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      theme: themeObj,
      data: {
        label: handleNestedProp(contentObj, 'contentObj.link3.label'),
        url: handleNestedProp(contentObj, 'contentObj.link3.url'),
        priority: handleNestedProp(contentObj, 'contentObj.link3.priority'),
        openNewTab: handleNestedProp(contentObj, 'contentObj.link3.openNewTab'),
        icon: handleNestedProp(contentObj, 'contentObj.link3.icon')
      },
      classes: [_cardContent["default"].mobileFullWidth]
    })))));
  };
  var renderLayout = function renderLayout(params) {
    var contentObj = params.contentObj,
      themeObj = params.themeObj,
      layoutStr = params.layoutStr;
    if (contentObj === null) {
      return _div || (_div = /*#__PURE__*/_react["default"].createElement("div", null));
    }
    switch (layoutStr) {
      case 'highlow':
        return highLowRender(contentObj, themeObj);
      case 'medium':
        return mediumRender(contentObj, themeObj);
      case 'large':
        return largeRender(contentObj, themeObj);
      default:
        return _div2 || (_div2 = /*#__PURE__*/_react["default"].createElement("div", null));
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _cardContent["default"].contentWrapper + " " + _cardContent["default"][handleNestedProp(content, 'content.description.textAlignment')] + " " + (theme[themeAlignment + "-xs"] ? theme[themeAlignment + "-xs"] : '') + " " + (editorialLayout === 'large' && _cardContent["default"].addContentPadding)
  }, renderLayout({
    contentObj: content,
    themeObj: theme,
    layoutStr: editorialLayout,
    themeAlignment: themeAlignment,
    config: config
  }));
};
CardContent.displayName = 'CardContent';
CardContent.defaultProps = {
  config: {}
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(CardContent);
exports["default"] = _default;